let cardItem = document.querySelectorAll(".card--item:not(.card--item__quicklinks):not(.card--item__usp):not(.card--item__cta)");
let cardUpper = document.querySelector(".card--upper");
var container = document.getElementsByTagName("body")[0];
var quicklinkCard = document.querySelectorAll(".card--item__quicklinks");
var ctaCard = document.querySelectorAll(".card--item__cta");

const vlink = document.querySelectorAll(".variants__item[data-href]");
for (let i = 0; i < vlink.length; i++) {
    vlink[i].addEventListener("click", function() {
        console.log( this );
        location.href = this.getAttribute("data-href");
        event.preventDefault();
    });
}

var resizeTimer;
if (cardUpper) { //&& window.innerWidth > 991
    setTimeout(() => {
        resizeCards(cardItem);
        resizeCards(quicklinkCard);
        resizeCards(ctaCard);

        onImagesLoaded(container, function () {
            resizeCards(cardItem);
            resizeCards(quicklinkCard);
            resizeCards(ctaCard);
        });

    }, 200);


    window.addEventListener('resize', function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            resizeCards(cardItem);
            resizeCards(quicklinkCard);
            resizeCards(ctaCard);
        }, 250);
    });
}

// quicklinks cards


export default function resizeCards(card) {
    for (var i = 0; i < card.length; ++i) {
        let cardsHidden = card[i].querySelector(".card--hidden");
        if (cardsHidden) {
        let cardsContent = card[i].querySelector(".card--content");
        let cardsUpperHeight = card[i].querySelector(".card--upper").clientHeight;
        cardsContent.style.height = cardsUpperHeight + "px";
            //mouseover;
            cardsContent.parentElement.addEventListener("mouseover", function () {
                let cardsHiddenHeight = cardsHidden.clientHeight;
                this.querySelector(".card--upper").style.transform = "translateY(-" + cardsHiddenHeight + "px)";
                this.querySelector(".card--hidden").style.display = "block";
                this.querySelector(".card--hidden").style.transform = "translateY(-" + cardsHiddenHeight + "px)";
            });
            cardsContent.parentElement.addEventListener("mouseleave", function () {
                this.querySelector(".card--upper").style.transform = "translateY(0)";
                this.querySelector(".card--hidden").style.transform = "translateY(0)";
            });
            cardsContent.parentElement.addEventListener("touchstart", function () {
                let cardsHiddenHeight = cardsHidden.clientHeight;
                this.querySelector(".card--upper").style.transform = "translateY(-" + cardsHiddenHeight + "px)";
                this.querySelector(".card--hidden").style.display = "block";
                this.querySelector(".card--hidden").style.transform = "translateY(-" + cardsHiddenHeight + "px)";
            });
            cardsContent.parentElement.addEventListener("touchmove", function () {
                this.querySelector(".card--upper").style.transform = "translateY(0)";
                this.querySelector(".card--hidden").style.transform = "translateY(0)";
            });
        }
    }

    var cards = document.querySelectorAll(".cards");

    for (var i = 0; i < cards.length; ++i) {
        cards[i].classList.add("s");
    }
}



function onImagesLoaded(container, event) {
    var images = container.getElementsByTagName("img");
    var loaded = images.length;
    for (var i = 0; i < images.length; i++) {
        if (images[i].complete) {
            loaded--;
        }
        else {
            images[i].addEventListener("load", function () {
                loaded--;
                if (loaded == 0) {
                    event();
                }
            });
        }
        if (loaded == 0) {
            event();
        }
    }
}










// WEBPACK FOOTER //
// ./scripts/components/cards.js